import Raven from 'raven-js';
import { useEffect } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import ExamFinishedScreenLayout from './ExamFinishedScreenLayout';
import { jsx as _jsx } from "react/jsx-runtime";
const ExamAwardNotGeneratedScreen = ({
  track,
  mostRecentExamAttempt,
  pendingPracticalExercises
}) => {
  var _track$exam;
  useEffect(() => {
    if (track.id && mostRecentExamAttempt) {
      Raven.captureMessage('Award failed to generate', {
        extra: {
          examAttemptId: mostRecentExamAttempt.id,
          trackId: track.id
        }
      });
    }
  }, [mostRecentExamAttempt, track.id]);
  return /*#__PURE__*/_jsx(ExamFinishedScreenLayout, {
    heading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.exams.finished.awardNotGeneratedHeader"
    }),
    illustration: /*#__PURE__*/_jsx(Illustration, {
      name: "announcement"
    }),
    mostRecentExamAttempt: mostRecentExamAttempt,
    pendingPracticalExercises: pendingPracticalExercises,
    prompt: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.exams.finished.yourScoreWas",
      options: {
        correctQuestionCount: mostRecentExamAttempt && mostRecentExamAttempt.score,
        totalQuestionCount: track && ((_track$exam = track.exam) === null || _track$exam === void 0 ? void 0 : _track$exam.length) || 0
      }
    }),
    subheading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.exams.finished.awardNotGenerated",
      options: {
        courseName: track && track.name
      }
    }),
    track: track
  });
};
export default ExamAwardNotGeneratedScreen;